module.exports = __webpack_public_path__ + "img/about.29991b03.png";